import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  Card,
  Autocomplete,
  CardMedia,
  Avatar,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseArticles } from "./UseArticles";
import { useSnackbar } from "notistack";
import { FileUploader } from "react-drag-drop-files";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import copy from "copy-text-to-clipboard";

export default function ArticleImagesGrid(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const ImageType = [
    { id: 1, type: "بنر" },
    { id: 2, type: "محتوا" },
  ];
  const { enqueueSnackbar } = useSnackbar();
  const { GetArticleImages, AddArticleImage, DeleteArticleImage } =
    UseArticles();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [imageRes, setImageRes] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [openDialogImage, setOpenDialogImage] = useState({
    show: false,
    image: undefined,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [state, setState] = useState({
    id: 0,
    articleID: "",
    imageType: "",
    rowIndex: 1,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });

    if (state.imageType == 1) {
      var lastrowIndex = Math.max.apply(
        Math,
        imageRes &&
          imageRes.map(function (o) {
            if (o.imageType == 1) {
              return o.rowIndex;
            } else {
              return 1;
            }
          })
      );
    } else if (state.imageType == 2) {
      var lastrowIndex = -Infinity;
    }
    setState({
      ...state,
      rowIndex: lastrowIndex != -Infinity ? lastrowIndex + 1 : 1,
    });
  };

  useEffect(() => {
    if (props.articleID) {
      setProgress(true);
      GetArticleImages(props.articleID, (callback) => {
        setImageRes(callback);
      });
    }
  }, [props.articleID]);

  const newFunc = () => {
    setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      // hide: true,
    },
    {
      field: "rowIndex",
      width: 100,
      align: "center",
      headerName: "اولویت",
      headerAlign: "center",
    },
    {
      field: "image",
      width: 120,
      align: "center",
      headerName: "تصویر",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Avatar sx={{ borderRadius: 0 }} src={cellValues.row.image}></Avatar>
        );
      },
    },
    {
      field: "imageType",
      width: 200,
      align: "center",
      headerName: "نوع تصویر",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.imageType == 1 ? "بنر" : "محتوا"}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 200,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="نمایش">
              <IconButton
                onClick={() => {
                  setOpenDialogImage({
                    show: true,
                    image: cellValues.row.image,
                  });
                }}
              >
                <ImageIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="کپی">
              <IconButton
                onClick={() => {
                  copy(cellValues.row.image);
                  enqueueSnackbar("آدرس تصویر در کلیپ بورد شما کپی شد ", {
                    variant: "info",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                }}
              >
                <FileCopyIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
          width: "100px",
          height: "100px",
        }}
        fullWidth
        maxWidth="sm"
        open={openDialogImage.show}
        onClose={() => {
          setOpenDialogImage({
            show: false,
            image: "",
          });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              mx: "auto",
            }}
          >
            <CardMedia
              sx={{ mb: 4, minWidth: "150px", minHeight: "150px" }}
              component="img"
              alt="green iguana"
              image={openDialogImage.image}
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setOpenDialogImage({
                  show: false,
                  image: "",
                });
              }}
            >
              بستن
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            articleID: props.articleID,
            id: 0,
            imageType: "",
            rowIndex: "",
          });
          setImgState({
            file: undefined,
            url: "",
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Autocomplete
              size="small"
              onChange={(event, newValue) => {
                setState({
                  ...state,
                  imageType: newValue,
                  articleID: props.articleID,
                });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return ImageType.find((m) => m.id == option).type;
                }
                return "";
              }}
              sx={{ width: "50%", mb: 3 }}
              options={ImageType?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  {...params}
                  label="نوع تصویر را نتخاب کنید"
                />
              )}
            />
            {state.imageType && (
              <FileUploader
                multiple={true}
                handleChange={(evt) => handleChangeImage(evt)}
                name="file"
                types={fileTypes}
                children={
                  state.imageType == 2 ? (
                    <Box sx={{ width: "150px", height: "150px" }}>
                      <Card
                        sx={{
                          p: 1,
                          border: "1px",
                          borderStyle: "dashed",
                          borderColor: "secondary.main",
                          borderRadius: 4,
                          boxShadow: 0,
                          cursor: "pointer",
                        }}
                      >
                        <CardMedia
                          component="img"
                          sx={{ width: "100%", height: "100%" }}
                          image={
                            imgState.url
                              ? imgState.url
                              : "/static/img/no-photos.png"
                          }
                        />
                      </Card>
                    </Box>
                  ) : (
                    <Box>
                      <Card
                        sx={{
                          width: "400px",
                          height: "150px",
                          p: 1,
                          border: "1px",
                          borderStyle: "dashed",
                          borderColor: "secondary.main",
                          borderRadius: 4,
                          boxShadow: 0,
                          cursor: "pointer",
                        }}
                      >
                        <CardMedia
                          component="img"
                          sx={{ width: "100%", height: "100%" }}
                          image={
                            imgState.url
                              ? imgState.url
                              : "/static/img/nobanner.jpg"
                          }
                        />
                      </Card>
                    </Box>
                  )
                }
              />
            )}
            <Box sx={{ mt: 3 }}>
              <Button
                onClick={() => {
                  if (
                    state.imageType == undefined ||
                    imgState.file == undefined
                  ) {
                    enqueueSnackbar("لطفا تصویر و نوع آن را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    setProgress(true);
                    AddArticleImage(state, imgState.file, () => {
                      GetArticleImages(props.articleID, (callback) => {
                        setImageRes(callback);
                      });
                      setState({
                        articleID: props.articleID,
                        id: 0,
                        imageType: "",
                        rowIndex: "",
                      });
                      setImgState({
                        file: undefined,
                        url: "",
                      });
                      setOpenDialog(false);
                    });
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    articleID: props.articleID,
                    id: 0,
                    imageType: "",
                    rowIndex: "",
                  });
                  setImgState({
                    file: undefined,
                    url: "",
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={imageRes ? imageRes : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={imageRes && imageRes.length ? imageRes.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: imageRes && imageRes.length ? imageRes.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "imageType",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تصویر"}
        callback={() => {
          setProgress(true);
          DeleteArticleImage(deleteState.id, () => {
            GetArticleImages(props.articleID, (callback) => {
              setImageRes(callback);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
